module.exports = __webpack_public_path__ + "templates.product_review_entry-a4d5320f.html";